<template>
  <div class="qrcode-wrapper d-flex flex-column align-items-end">
    <canvas ref="qrcode" class="nobreak" id="qrcode" />
    <div class="qrcode-title">{{ onlineQrcode }}</div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Locale from '../../../services/locale'

export default {
  name: 'QRcodeAction',
  props: {
    localeService: Locale,
  },
  computed: {
    onlineQrcode() {
      return this.localeService.getConstantTranslationByKey('online-qrcode')
    },
  },
  mounted() {
    const { search, origin, pathname } = window.location
    const get = new URLSearchParams(search)
    get.delete('print')
    const url = `${origin}${pathname}?${get.toString()}`
    window.winwinUrl = url

    QRCode.toCanvas(this.$refs.qrcode, url, {
      width: 90,
      height: 90,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
      margin: 0,
      errorCorrectionLevel: 'H',
    })
  },
}
</script>
